import { CurrentPage } from '@shared/Frontend/utils/routes.shared'
import { ApplicationPages } from '../allIncludedModules'
import { MonadsTestState } from '../libraries/monadsTest/monadsTest.state'

export type PageState = CurrentPage<Pages>

export type Pages = {
  empty: { url: [] }
  home: { url: [] }
  errorHandlingTest: { url: [] }
  aboutUs: { url: [] }
  contactUs: { url: [] }
  datesTest: { url: [] }
  monadsTest: { url: []; monadsTest: MonadsTestState }
} & ApplicationPages

export const initialPageState: PageState = { kind: 'empty', params: {} }
